export default "__VITE_ASSET__BbRTtq8Z__"